import { Modal, ModalType } from '@sprint/sprint-react-components';
import React, { FunctionComponent, useEffect, useState } from 'react';

interface Props {
    modalShown: boolean;
    stopId: number;
    stopEmail: string;
    closeModal: () => void;
    onSubmit: (id: number) => Promise<boolean>;
}

const CampaignsStopModal: FunctionComponent<Props> = (props: Props) => {
    const [stopId, setStopId] = useState<number>(props.stopId);

    useEffect(() => {
        setStopId(props.stopId);
    }, [props.stopId]);

    const onSubmit = async (): Promise<boolean> => {
        return props.onSubmit(stopId).then(() => {
            props.closeModal();
            return true;
        });
    };

    return (
        <Modal
            isOpen={props.modalShown}
            type={ModalType.YESNO}
            title="Abandon Dedicated Send"
            close={() => props.closeModal()}
            onSubmit={onSubmit}
        >
            <>
                Abandon the dedicated send of <strong>{props.stopEmail}</strong>? Emails already in progress will
                finish; nothing further will send. This can't be undone.
            </>
        </Modal>
    );
};

export default CampaignsStopModal;
